module.exports = __webpack_public_path__ + "static/media/carousel3.fa2396c4.webp";